module.exports = __webpack_public_path__ + "static/media/spotify.8ea995e5.svg";